
import store from '@/store';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { format, utcToZonedTime } from 'date-fns-tz';
import { timeZoneDefault } from '@/utils/PortalConstants';

import Icon from '@/components/UI/Icon.vue';
import Tooltip from '@/components/UI/Tooltip.vue';

import { User } from '@/models/main';

import * as routeNames from '@/router/routeNames';

export interface Routes {
  [key: string]: string;
}

@Component({
  components: {
    Icon,
    Tooltip,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
    ...mapState('moduleNotifications', { notifications: 'notifications' }),
  },
})
export default class NotificationsPanel extends Vue {
  public user!: User;
  public notifications;

  // Dates
  public format = format;
  public utcToZonedTime = utcToZonedTime;
  public timeZoneDefault = timeZoneDefault;

  // Notifications
  public only_unread = true;
  public panel_is_open = false;
  public loaderNextPage = false;
  public notificationHoveredId = -1;
  public notificationHoveredIdShowTooltip = false;

  public async handleScroll(e): Promise<void> {
    const { scrollTop, offsetHeight, scrollHeight } = e.target;
    if (scrollTop + offsetHeight >= scrollHeight - 400) {
      //
      if (!this.loaderNextPage) {
        this.loaderNextPage = true;
        await store.dispatch('moduleNotifications/getNextPage');
        this.loaderNextPage = false;
      }
    }
  }

  public async notificationsTabClicked(name: string) {
    const scrollSection = this.$refs.scrollSection as HTMLFormElement;
    if (scrollSection) {
      await scrollSection.scrollTo({ top: 0 });
    }
    await store.dispatch('moduleNotifications/setNotificationsCategory', name);
  }

  public notificationClicked(notification) {
    // Tickets – Zammad ticket page by `source_target_id`
    const routeNamesKeys: Routes = routeNames;
    const ids = String(notification.data.ids.join(','));
    // Check router match + current route
    if (
      notification.data?.name &&
      Object.keys(routeNamesKeys).includes(notification.data.name) &&
      ids !== this.$route.params.id
    ) {
      const data = {
        name: routeNamesKeys[notification.data.name],
        ...(notification.data.name === 'SEARCH' ? { query: { job_id: ids } } : { params: { id: ids } }),
      };
      this.$router.push(data);
    }
    store.dispatch('moduleNotifications/setNotificationAsRead', notification.id);
    this.panel_is_open = false;
  }

  // Notifications buttons clicks
  public portalNotificationsClicked() {
    this.panel_is_open = !this.panel_is_open;
  }
  // Outside the panel click
  public closeNotificationsPanel() {
    this.panel_is_open = false;
  }

  public unreadFilterClicked() {
    const scrollSection = this.$refs.scrollSection as HTMLFormElement;
    if (scrollSection) {
      scrollSection.scrollTo({ top: 0 });
    }
    store.dispatch('moduleNotifications/setNotificationsUnreadFilter', this.only_unread);
  }

  public async setNotificationAsReadClicked(id: number): Promise<void> {
    await store.dispatch('moduleNotifications/setNotificationAsRead', id);
  }

  public setNotificationAsUnreadClicked(id: number): void {
    store.dispatch('moduleNotifications/setNotificationAsUnread', id);
  }

  public setNotificationAllAsReadClicked(): void {
    store.dispatch('moduleNotifications/setNotificationsAllAsRead');
  }

  public loadMoreNotificationsClicked(): void {
    store.dispatch('moduleNotifications/getNotificationsNextPage');
  }

  public deleteNotificationClicked(id: number): void {
    store.dispatch('moduleNotifications/deleteNotification', id);
  }
}
